/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket } from '../use-order-ticket.js'
import { Loading, fmt, parseHtml, Flyout } from '../../twd'

export const CusipInfo = () => {
    const {cusip, bondInfo, bondInfoStatus, hasBondInfo, hasAttestCD, isTreasuryAuction } = useOrderTicket()
    const issue = bondInfo.issue || {}

    const [show, setShow] = React.useState(false)

    React.useEffect(() => {
        setShow(cusip && hasBondInfo)
    }, [cusip, hasBondInfo])

    return <React.Fragment>
        <Loading status={bondInfoStatus}>
        {show && <React.Fragment>
        {!isTreasuryAuction && <div className="row vertical-offset-xs">
            <div className="col-md-12"><hr aria-hidden={true} /></div>
            </div> }

        <div className="row vertical-offset-sm">
        <div className="col-md-12 col-xs-12">
            <div><Flyout
                label="Issuer"
                html={IssuerTooltip}
            /></div>
            <div className="h3 text-truncate" style={{marginBottom:'0px', maxWidth:'300px'}}>{fmt.issuer({
                issuer: parseHtml(issue.issue),
                cusip,
                showTradeHistory: 'Y',
                showBondDetail: 'Y',
                isTreasuryAuction,
                from:'order-ticket'
            })}</div>

            <div className="text-bold" dangerouslySetInnerHTML={{__html:issue.warningText}} />

        </div>
        </div>

        <div className="row vertical-offset-sm">
        <div className="col-md-12 col-xs-12">
            <div><Flyout
                label="Cusip"
                html={CusipTooltip}
                />
            </div>
            <div><label className="label text-bold">{cusip}</label></div>
        </div>
        </div>

        { hasAttestCD && <div className="row vertical-offset-sm"><div className="col-xs-12">
            <div className="universal-message universal-message-info"
                style={{backgroundColor:'#ffffff'}}
                role="alert">
                <div className="universal-message-content"
                    style={{width: '100%'}}>
                    Brokerage CD's are FDIC insured up to $250,000
                </div>
            </div>
        </div></div>}

        </React.Fragment>}
        </Loading>

    </React.Fragment>
}


const IssuerTooltip = `
    A legal entity (such as a corporation, government, or municipality) which borrows money by issuing bonds.
    The issuer is obligated to pay the principal and interest on the bond.
`

const CusipTooltip = `
    CUSIP stands for Committee on Uniform Securities Identification Procedures. When issued,
    each bond is assigned a CUSIP number, comprised of nine alphanumeric characters to uniquely
    identify the security.
`


// WEBPACK FOOTER //
// ./src/order-ticket/form/cusip-info.js